import axios from 'axios'
import qs from 'qs'
import router from './../router'
const baseUrl = process.env.VUE_APP_BASE_URL;
console.log('baseUrl = ', baseUrl);
// let baseUrl = 'localhost:8080';
// http request 拦截器
axios.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        // 判断是否登录
        // if (store.state.token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
        //     config.headers.Authorization = `token ${store.state.token}`;
        // }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);
// http response 拦截器
axios.interceptors.response.use(
    function (response) {
        // Do something with response data
        // 根据返回值判断是否登录，如果未登录，则跳转至登录页面
        // debugger
        // console.log('response = ', response, response.data)
        if (response.data.status === -403) {
            let msg = response.data.msg;
            // alert(msg)

            router.push({
                name: "error",
                params: { error_msg: msg }
            });
            // next({ name: 'error', params: { error_msg: msg }})
            return false;
        }
        if (response.data.status === 302) {
            let redirecturl = response.headers.get('location')
            window.open(redirecturl, '_blank')
        }
        else {
            return response
        }

    },
    function (error) {
        // Do something with response error
        // if (error.response) {
        //     switch (error.response.status) {
        //         case 401:
        //             // 返回 401 清除token信息并跳转到登录页面
        //             store.commit(types.LOGOUT);
        //     }
        // }
        // return Promise.reject(error.response.data)   // 返回接口返回的错误信息
        return error
    }
);



export default {
    longpost(url, data) {
        return axios({
            method: 'post',
            // url: baseUrl + url,
            url: url,
            data: qs.stringify(data),
            headers: {
                // 'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            timeout: 1000000,
            responseType: 'json',
            responseEncoding: 'utf8',
            transformResponse: [function (data) {
                // Do whatever you want to transform the data
                // return JSON.parse(data);
                return data
            }]
        }).then(function (response) {
            // checkStatus(response);
            return response;
        }).catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        })
    },
    post(url, data) {
        return axios({
            method: 'post',
            url: url,
            // url: baseUrl + url,
            // url: url,
            // data: qs.stringify(data),
            data: data,
            headers: {
                // 'X-Requested-With': 'XMLHttpRequest',
                // 'Content-Type': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            timeout: 20000,
            responseType: 'json',
            responseEncoding: 'utf8',
            transformResponse: [function (data) {
                // Do whatever you want to transform the data
                // return JSON.parse(data);
                return data
            }]
        }).then(function (response) {
            // checkStatus(response);
            return response;
        }).catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        })
    },
    get(url, params) {
        return axios({
            method: 'get',
            // url: baseUrl + url,
            url: url,
            params: params,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
                // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            timeout: 8000,
            responseType: 'json',
            responseEncoding: 'utf8',
            maxRedirects: 0,
            transformResponse: [function (data) {
                // Do whatever you want to transform the data
                // console.log("data");
                // console.log(data);
                return data;
            }]
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
            return error;
        })
    },
    upload(url, params, config) {
        return axios({
            method: 'post',
            // baseURL: baseUrl,
            url: url,
            config,
            data: params,
            timeout: 1000000,
            headers: {
                'Content-Type': 'multipart/form-data; charset=UTF-8'
            },
            responseType: 'json',
            responseEncoding: 'utf8',
            transformResponse: [function (data) {
                // Do whatever you want to transform the data
                console.log(data);
                return data;
            }]
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
            return error;
        })
    }


}


